<template>
	<component v-bind="linkProps(to)">
		<slot></slot>
	</component>
</template>

<script>
export default {
	name: 'Link',

	props: {
		to: {
			type: [ String, Object ],
			required: true
		},
		target: {
			type: String,
			default: '_self',
		},
	},

	methods: {
		linkProps (url) {
			if (typeof url === 'string' && url.match(/^(#)|(wwww?\.)|(https?|ftp):\/\//)) {
				return {
					is: 'a',
					href: url,
					target: this.target,
					rel: 'noopener'
				}
			}
			return {
				is: 'router-link',
				to: url
			}
		}
	},
};
</script>
